import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as c } from "react";
const n = ({
  title: l,
  titleId: o,
  ...r
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M145.207 858.693V165.306c0-54.015 42.709-96.722 96.722-96.722H547.17c111.797 0 198.47 31.404 256.253 89.187 48.99 48.99 75.368 118.078 75.368 200.981v2.513c0 138.175-69.087 223.592-175.86 267.558l134.407 163.298c18.843 23.867 31.404 43.964 31.404 74.112 0 54.015-45.221 89.187-91.698 89.187-43.964 0-72.855-21.354-95.466-50.245l-188.42-238.667H338.654v192.189c0 54.015-42.709 96.722-96.722 96.722s-96.722-42.709-96.722-96.722zm193.446-363.024H534.61c94.211 0 148.223-50.245 148.223-124.358v-2.513c0-82.906-57.782-125.613-151.993-125.613H338.651v252.483z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = c(n);
export {
  m as default
};
